<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <ul class="list features">
            <li class="item">
              <div class="feature-wrapper">
                <img src="./../images/feature_1.svg" class="img" />
              </div>
              <div class="title small">Secure and Stable</div>
              <div class="desc">
                We offer a secure, user-friendly platform where anyone — from
                beginner to pro — can trade crypto their way.
              </div>
            </li>
            <li class="item">
              <div class="feature-wrapper">
                <img src="./../images/feature_2.svg" class="img" />
              </div>
              <div class="title small">24 / 7 Support</div>
              <div class="desc">
                Reach out anytime — our support team is committed to resolving
                your issues as quickly as possible.
              </div>
            </li>
            <li class="item">
              <div class="feature-wrapper">
                <img src="./../images/feature_3.svg" class="img" />
              </div>
              <div class="title small">VIP Service</div>
              <div class="desc">
                Priority access. Powerful limits. Lightning-fast trades. Built
                for investors who demand more.
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="section section-2">
        <div class="wrapper">
          <div class="img-wrapper">
            <img src="../images/section_1.svg" alt="" />
          </div>

          <div class="text">
            <h2 class="text__title">
              Advance your financial future through crypto
            </h2>
            <h5 class="text__subtitle desc">
              Step into a world of fast, low-cost crypto trading and endless
              potential. Be part of a platform shaping financial innovation
            </h5>
            <div class="get list">
              <div class="item">
                <div class="item__title">Get <span>Bitcoin</span> Now</div>
                <div class="item__text">
                  Enter the crypto revolution with the market’s top player.
                  Simple, instant exchanges just for you
                </div>
              </div>
              <div class="item">
                <div class="item__title">Get <span>Ethereum</span> Now</div>
                <div class="item__text">
                  Tap into Ethereum’s smart contracts and dApps for speed and
                  endless innovation
                </div>
              </div>
              <div class="item">
                <div class="item__title">Get <span>USDC</span> Now</div>
                <div class="item__text">
                  Secure your assets with USDC, delivering clarity and
                  reliability in the evolving crypto space
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section-3">
        <div class="wrapper">
          <h2 class="title">Built on technology, earned through trust</h2>
          <div class="content">
            <div class="content__text desc">
              Harness the power of our technology to elevate the security of
              your crypto transactions. Every trade with us is protected by
              multiple layers of advanced safeguards, creating a secure
              environment where your trust is respected and your assets are
              rigorously defended
            </div>

            <router-link
              v-if="$parent.isAuth"
              :to="{ name: 'BuyCrypto' }"
              class="button black"
            >
              Get started
            </router-link>
            <button
              v-else
              @click="$parent.openSignInModal"
              class="button black"
            >
              Get started
            </button>
          </div>
        </div>
      </div>

      <div class="section section-4">
        <div class="wrapper">
          <img class="figure" src="../images/figure_4.svg" alt="" />
          <div class="content">
            <h3 class="title">Your one stop place for crypto assets</h3>

            <div class="card">
              <div class="card__title title">More crypto, less fee</div>
              <div class="card__text desc">
                Trade more, worry less — our competitive fees help you unlock
                your full potential
              </div>
            </div>
            <div class="card">
              <div class="card__title title">Simplify your journey</div>
              <div class="card__text desc">
                Our user-friendly platform simplifies buying, selling, and
                trading cryptocurrencies for everyone—from beginners to experts
              </div>
            </div>
            <div class="card">
              <div class="card__title title">Do your own way</div>
              <div class="card__text desc">
                Trade your way with a variety of payment methods for seamless
                buying and selling
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section-5">
        <div class="wrapper">
          <img src="../images/figure_5.svg" alt="" class="figure" />
          <img src="../images/figure_2.svg" alt="" class="figure" />
          <div class="title white">
            Take Your Crypto Ambitions to the Next Level
          </div>

          <div class="desc white">
            Explore the crypto world with fast, cost-effective trading across
            diverse pairs — all supported by our trusted platform
          </div>

          <form class="form">
            <input
              placeholder="Enter your email"
              type="email"
              required
              class="input"
            />
            <button type="submit" class="button black">Get started</button>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
// import ContactForm from "@/components/ContactForm.vue";
// import ExchangeButton from "@/components/ExchangeButton.vue";

export default {
  name: "Home",
  props: [],
  components: {
    // ExchangeButton,
    // ContactForm
  },
  data: function () {
    return {
      activePanels: [],
      exchangeList: [],
      giveAmount: 100,
      takeAmount: 0,
      chosenCrypto: {},
      fiatToCrypto: true,
    };
  },
  computed: {
    exchangeListUpdated() {
      return this.exchangeList.filter((item) => item.currency === "EUR");
    },
    total() {
      if (this.chosenCrypto.price) {
        if (this.fiatToCrypto) {
          return `${
            this.giveAmount / this.chosenCrypto.price
          } <span class="currency">${this.chosenCrypto.crypto_currency.toUpperCase()}</span>`;
        }

        return `${
          this.chosenCrypto.price * this.giveAmount
        } <span class="currency">EUR<span/>`;
      }

      return 0;
    },
  },
  mounted() {
    if (this.$route.query["redirect"]) {
      this.$parent.openSignInModal();
    }

    this.getExchangeList();
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/tv.js";
    script.async = true;
    script.onload = this.initializeWidget;
    document.body.appendChild(script);
  },
  methods: {
    checkAuth() {
      if (this.$parent.isAuth) {
        this.$router.push({ path: "/buy-crypto" });
      } else {
        this.$parent.openSignInModal();
      }
    },
    getExchangeList() {
      this.$http
        .get(process.env.VUE_APP_API + "exchange-top")
        .then((res) => {
          this.exchangeList = res.data.payload;
          this.chosenCrypto = res.data.payload[0];
          this.changeTakeAmount(this.giveAmount);
        })
        .catch(() => {});
    },
    changeTakeAmount(newValue) {
      if (this.chosenCrypto.price) {
        this.takeAmount = newValue / this.chosenCrypto.price;
      } else {
        this.takeAmount = 0;
      }
    },
    toggleAnswer(index) {
      if (this.isActiveAnswer(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActiveAnswer(index) {
      return this.activePanels.includes(index);
    },
    initializeWidget() {
      new window.TradingView.widget({
        autosize: true,
        symbol: "BITSTAMP:BTCUSD",
        interval: "D",
        timezone: "Etc/UTC",
        theme: "light",
        style: "1",
        locale: "en",
        gridColor: "#F1F3F8",
        toolbar_bg: "#E1E7F1",
        enable_publishing: false,
        allow_symbol_change: true,
        container_id: "tradingview-widget",
      });
    },
  },
};
</script>
